import { httpClient } from './httpClient';

export const fetchCampaigns = async (companyId) => {
  const response = await httpClient.get(`/campaigns/${companyId}`);
  return response.data;
};

export const updateCampaignStatus = async (campaignId, isActive) => {
  const response = await httpClient.put(`/campaigns/${campaignId}/status`, {
    is_active: isActive,
  });
  return response.data;
};

export const createCampaign = async (
  companyId,
  campaignCode,
  planName,
  priceId,
  planType,
  upgradePlanId,
  upgradeType,
  usageDays,
  exclusivePlan,
  repeatPlanId,
  referrerUrls,
  isMember,
  memberIdValidationType,
  memberIdMaxDigits,
  memberIdMinDigits,
  memberIdLabel
) => {
  // referrerUrlsがカンマ区切りの文字列の場合、配列に変換
  let referrerUrlsArray = null;
  if (referrerUrls && referrerUrls.trim()) {
    referrerUrlsArray = referrerUrls
      .split(',')
      .map((url) => url.trim())
      .filter((url) => url.length > 0);
  }

  const response = await httpClient.post(`/campaigns/store`, {
    company_id: companyId,
    campaign_code: campaignCode,
    plan_name: planName,
    price_id: priceId,
    planType: planType,
    upgrade_plan_id: upgradePlanId || null,
    upgradeType,
    usage_days: usageDays ?? null,
    exclusive_plan: exclusivePlan,
    repeat_plan_id: repeatPlanId || null,
    referrer_urls: referrerUrlsArray,
    is_member: isMember || false,
    member_id_validation_type: memberIdValidationType || null,
    member_id_max_digits: memberIdMaxDigits || null,
    member_id_min_digits: memberIdMinDigits || null,
    member_id_label: memberIdLabel || null,
  });
  return response.data;
};

export const checkCampaignActive = async (priceId) => {
  const response = await httpClient.get(`/campaigns/check-active`, {
    params: { price_id: priceId },
  });
  return response.data;
};
export const checkCampaignCode = async (exclusive_plan) => {
  if (!exclusive_plan) return { exists: false };

  const response = await httpClient.get('/campaigns/check-exclusive', {
    params: { exclusive_plan: exclusive_plan },
  });

  return response.data;
};

export const checkReferrer = async (priceId, referrer) => {
  const response = await httpClient.get('/campaigns/check-referrer', {
    params: { price_id: priceId, referrer: referrer },
  });
  return response.data;
};
